import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  clearFilter,
  setFilterType,
  setSearch,
} from "../../redux/saleReturn/saleReturnSlice";

const SaleReturnHeader = () => {
  const filter = useSelector((state) => state.saleReturn);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [voucherCode, setVoucherCode] = useState("");
  const [keyword, setKeyword] = useState("");
  const dispatch = useDispatch();

  const handleFilter = () => {
    dispatch(setFilterType({ startDate, endDate, voucherCode }));
    dispatch(setSearch(keyword));
  };

  const handleReset = () => {
    setStartDate("");
    setEndDate("");
    setVoucherCode("");
    setKeyword("");
    dispatch(clearFilter());
  };

  return (
    <Box sx={{ p: 3, bgcolor: "background.paper", borderRadius: 2, mb: 3 }}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ fontSize: "13px", color: "#444", mb: 0.5 }}>Start Date</Box>
          <TextField
            fullWidth
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            size="small"
            inputProps={{ placeholder: "mm/dd/yyyy" }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ fontSize: "13px", color: "#444", mb: 0.5 }}>End Date</Box>
          <TextField
            fullWidth
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            size="small"
            inputProps={{ placeholder: "mm/dd/yyyy" }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ fontSize: "13px", color: "#444", mb: 0.5 }}>Voucher Code</Box>
          <TextField
            fullWidth
            value={voucherCode}
            onChange={(e) => setVoucherCode(e.target.value)}
            size="small"
            placeholder="Search voucher code"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ fontSize: "13px", color: "#444", mb: 0.5 }}>Keyword</Box>
          <TextField
            fullWidth
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            size="small"
            placeholder="Customer, return code or reason"
          />
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button variant="contained" onClick={handleFilter} size="small">
              Search
            </Button>
            <Button variant="outlined" onClick={handleReset} size="small">
              Reset
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SaleReturnHeader;
